import { makeStyles } from '@material-ui/core/styles';

const commonStyle = () => ({
  boxShadow: 'none',
  minWidth: 120,
  height: 30,
  minHeight: 30,
  textTransform: 'none',
  fontSize: 16,
  lineHeight: "20px",
  padding: '0 8px',
  fontWeight: "bold",
  color: 'var(--white)',
  backgroundColor: 'var(--primary)',
  fontFamily: "Proxima Nova",
  '&:hover': {
    backgroundColor: 'var(--primary)',
    boxShadow: 'none',
  },
  '&:active': {
    backgroundColor: 'var(--primary)',
    boxShadow: 'none',
  },
  '&:focus': {
    backgroundColor: 'var(--primary)',
    boxShadow: 'none',
  },
  '&:disabled': {
    color: 'var(--white)',
    backgroundColor: 'var(--light-grey)',
    boxShadow: 'none',
  }
});

const ButtonStyles = (theme) => ({
  buttonStyle: commonStyle(),
  cancelButtonStyle: {
    boxShadow: 'none',
    minWidth: 120,
    height: 30,
    minHeight: 30,
    textTransform: 'none',
    fontSize: 16,
    lineHeight: "20px",
    padding: 0,
    border: "1px solid var(--main-grey)",
    color: 'var(--dark-grey)',
    fontWeight: "bold",
    backgroundColor: 'var(--white)',
    fontFamily: "Proxima Nova",
    '&:hover': {
      backgroundColor: 'var(--white)',
      boxShadow: 'none',
    },
    '&:active': {
      backgroundColor: 'var(--white)',
      boxShadow: 'none',
    },
    '&:focus': {
      backgroundColor: 'var(--white)',
      boxShadow: 'none',
    },
  },
  startGutter: {
    marginLeft: 8
  },
  endGutter: {
    marginRight: 8
  },
  flexFill: {
    display: 'flex',
    flexGrow: 1,
  },
  outlinedButtonStyle: {
    boxShadow: 'none',
    minWidth: 120,
    height: 30,
    minHeight: 30,
    textTransform: 'none',
    fontSize: 16,
    lineHeight: "20px",
    padding: 0,
    border: "1px solid var(--primary)",
    color: 'var(--primary)',
    fontWeight: "bold",
    backgroundColor: 'var(--white)',
    fontFamily: "Proxima Nova",
    '&:hover': {
      backgroundColor: 'var(--white)',
      boxShadow: 'none',
    },
    '&:active': {
      backgroundColor: 'var(--white)',
      boxShadow: 'none',
    },
    '&:focus': {
      backgroundColor: 'var(--white)',
      boxShadow: 'none',
    },
    '&:disabled': {
      border: '1px solid var(--light-grey)',
      color: 'var(--light-grey)',
      boxShadow: 'none',
    },
  },
});

export const ButtonStylesV2 = (theme = {}) => ({
  buttonStyle: {
    boxShadow: 'none',
    minWidth: 120,
    height: 30,
    minHeight: 30,
    width: '100%',
    textTransform: 'none',
    fontSize: 16,
    lineHeight: '20px',
    padding: '0 8px',
    backgroundColor: 'var(--primary-v2)',
    border: '1px solid var(--primary-v2)',
    color: 'var(--white)',
    fontFamily: "Proxima Nova",
    '&:hover': {
      backgroundColor: 'var(--primary-v2)',
      boxShadow: 'none',
    },
    '&:active': {
      backgroundColor: 'var(--primary-v2)',
      boxShadow: 'none',
    },
    '&:focus': {
      backgroundColor: 'var(--primary-v2)',
      boxShadow: 'none',
    },
    '&:disabled': {
      color: 'var(--white)',
      backgroundColor: 'var(--light-grey)',
      border: '1px solid var(--light-grey)',
      boxShadow: 'none',
    },
  },
  noOutlinedButtonStyle: {
    boxShadow: 'none',
    minWidth: 120,
    height: 30,
    minHeight: 30,
    width: '100%',
    textTransform: 'none',
    fontSize: 16,
    lineHeight: '20px',
    padding: '0 8px',
    // backgroundColor: 'var(--white)',
    // border: '1px solid var(--white)',
    color: 'var(--primary-v2)',
    fontFamily: "Proxima Nova",
    '&:hover': {
      // backgroundColor: 'var(--white)',
      boxShadow: 'none',
    },
    '&:active': {
      // backgroundColor: 'var(--white)',
      boxShadow: 'none',
    },
    '&:focus': {
      // backgroundColor: 'var(--white)',
      boxShadow: 'none',
    },
    '&:disabled': {
      color: 'var(--light-grey)',
      // backgroundColor: 'var(--white)',
      // border: '1px solid var(--white)',
      boxShadow: 'none',
    },
  },
  startGutter: {
    marginLeft: 8
  },
  endGutter: {
    marginRight: 8
  },
});

export const useLoaderStyles = makeStyles((theme) => ({
  root: {
    position: 'relative',
  },
  default: {
    color: 'var(--white)',
  },
}));

export default ButtonStyles;
